import Vue from 'vue'
import VueJsToggleButton from 'vue-js-toggle-button/dist/ssr.index'
import VueCountdown from '@chenfengyuan/vue-countdown'

Vue.use(VueJsToggleButton)
Vue.component(VueCountdown.name, VueCountdown)
